import { NavItem } from 'src/common/NavBar/TopLevelNavItemContext';

export const nonRideOrderingPortalTabs: NavItem[] = [
  { name: 'Scheduling', href: '/team' },
  { name: 'Accounts', href: '/team/accounts' },
  { name: 'Drivers', href: '/team/driver-profile' },
  { name: 'Attendants', href: '/team/attendant-profile' },
];
